/**
 * orga app | admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MessageResponse { 
    readonly is_error?: boolean;
    error?: string;
    readonly properties?: { [key: string]: string; };
    user_id?: string;
    message_id?: string;
}

